import $ from 'jquery';
import { shareTextToWhatsApp } from 'share-text-to-whatsapp';


$('.share-to-whatsapp').on('click', function () {
    shareTextToWhatsApp($(this).data('link'))
});